/* Protocol 35: Validate lei in elections */
(function( $ ) {
		'use strict';

		let leiCheckMessage  = $( '#lei-check-message' ),
		    nameCheckMessage = $( '#name-check-message' ),
		    leiWarningWrap   = $( '#lei-warning-wrap' ),
		    leiWarning       = $( '#lei-warning' ),
		    eOrgname         = $( '#e-org-name-val' ),
		    eIdentifier      = $( '#e-identifier-val' ),
		    ePrimaryEntity   = $( '#e-select-primary-identifier' ),
		    eRegulatedEntity = $( '[name=\'e_cb_radio_1_val\']' );

		eOrgname.change( triggerCompELeiValidation );
		eIdentifier.change( triggerCompELeiValidation );
		ePrimaryEntity.change( clearLeiValidationStatus );

		function clearLeiValidationStatus() {
			nameCheckMessage.hide();
			leiCheckMessage.hide();
			ajaxSpinner.hide();
		}

		function triggerCompELeiValidation() {
			if ( ePrimaryEntity.val() === 'lei' && eRegulatedEntity.val() === '1' ) {
				nameCheckMessage.show();
				leiCheckMessage.show();
				validateLei( eOrgname.val(), eIdentifier.val(), '', 'election', '' );
			} else {
				leiCheckMessage.hide();
			}
		}

		eRegulatedEntity.change( function() {
			if ( eRegulatedEntity.is( ':checked' ) ) {
				let eRegulatedEntityVal = eRegulatedEntity.val();

				if ( eRegulatedEntityVal === '1' ) {
					leiCheckMessage.show();
					leiWarningWrap.show();
					leiWarning.prop( 'checked', false );
				}

				if ( eRegulatedEntityVal === '2' ) {
					eiCheckMessage.hide();
					leiWarningWrap.hide();
					leiWarning.prop( 'checked', true );
				}
			}
		} );

		setTypeLeiValidation( 0 );

		$( '#adherence-type-35' ).change( function() {
			let i = $( '#adherence-type-35' ).val();
			//resets the messages.
			$('[id^="name-check-message-type-').hide();
			$('[id^="lei-check-message-type-').hide();
			setTypeLeiValidation( i );
		} );

		function setTypeLeiValidation( i ) {
			let nameMessage   = `name-check-message-type-${i}`,
			    leiMessage    = `lei-check-message-type-${i}`,
			    primaryEntity = $( '[name=\'primary_entity_type_' + i + '\']' );

			primaryEntity.change( function() {
				if ( primaryEntity.val() === 'lei' ) {
					$( '#lei-warning-wrap-type' ).show();
					$( '#lei-warning-type' ).prop( 'checked', false );
				} else {
					$( '#' + nameMessage ).hide();
					$( '#' + leiMessage ).hide();
				}

			} );

			let nameOrg = `org_name_${i}`;
			let nameLei = `adh_type_identifier_${i}`;
			let primary_entity_type_i = `primary_entity_type_${i}`;
			$( '[name=\'' + nameOrg + '\'], [name=\'' + nameLei + '\']' )
				.change( function() {
					if ( $( '[name=\'' + primary_entity_type_i + '\']' ).val() === 'lei' ) {
						$( '#' + nameMessage ).show();
						$( '#' + leiMessage ).show();
						validateLei( $( '[name=\'org_name_' + i + '\']' )
							             .val(), $( '[name=\'adh_type_identifier_' + i + '\']' )
							             .val(), '-type-' + i, 'type', i );
					} else {
						$( nameMessage ).hide();
						$( leiMessage ).hide();
					}
				} );
		}

		function validateLei( orgName, lei, type = '', checkboxId = '', option_selected = '' ) {
			let checkboxLeiWarning     = $( '#lei-warning-' + checkboxId ),
			    checkboxLeiWarningWrap = $( '#lei-warning-wrap-' + checkboxId );

			checkboxLeiWarning.attr( 'required', 'required' );

			$.ajax( {
				        type   : 'GET',
				        url    : `${wpApiSettings.root}isda/v1/validation-lei?lei=${lei}&name=${orgName}`,
				        success: function( data ) {
					        $( '#name-check-message' + type )
						        .text( data.name.message ).removeAttr( 'class' )
						        .addClass( 'alert alert-' + data.name.class );

					        $( '#lei-check-message' + type )
						        .text( data.lei.message ).removeAttr( 'class' )
						        .addClass( 'alert alert-' + data.lei.class );

							let orgFundName     = $( `input[name=org_name_${option_selected}]` ),
							orgParentName   = $( '#e-org-name-val' );

							//fill for auto-fill if empty.
						    if ( data.fund_name ) {
						        if ( checkboxId === 'type' && orgFundName.val() === '' ) {
						          orgFundName.val(data.fund_name);
						        } else if ( checkboxId === 'election' && orgParentName.val() === '' ) {
						          orgParentName.val(data.fund_name);
						        }
						    }

					        if ( data.name.status === 'success' && data.lei.status === 'success' ) {
						        checkboxLeiWarning.removeAttr( 'required', 'required' );
						        checkboxLeiWarningWrap.hide();
					        } else {
						        checkboxLeiWarning.prop( 'checked', false );
						        checkboxLeiWarningWrap.show();
					        }

					        console.log( data );
				        },
				        error  : function( data ) {
					        console.log( data );
				        }
			        } );
		}
	}
)( jQuery );
